import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Search from '@material-ui/icons/Search';
import classNames from 'classnames';
import store from 'src/store/configureStore';
import { push } from 'connected-react-router';
import GlobalMenu from 'src/ui/library/GlobalMenu/GlobalMenuContainer';
import intl from 'react-intl-universal';
import Tab from 'src/ui/library/Tab';

const HeaderPres = ({ headerName, isMobile }) => {
  const headerClass = classNames('header-container', {
    'header-mobile': isMobile,
  });

  const currentlocation = window.location.href;
  const showdashboard = currentlocation.includes('/powerbi');
  const labels = [headerName];
  const path = {
    'My Cases': '/cases',
    'Team Cases': '/cases/team',
    'Overview Cases': '/cases/overview',
    'Service Initiation': '/service-initiation',
  }

  return showdashboard && showdashboard ? null : (
    <Fragment>
      <header className={headerClass}>
        <Grid className="logo-container">
          <div className="logo-image">
            <img alt="Logo" src={process.env.PUBLIC_URL + '/images/EYLogo.svg'} />
          </div>
          <Hidden smDown>
            <span className="header-iml">
              <span className="header-text">{intl.get('header.headerName')}</span>
            </span>
          </Hidden>
          <Hidden mdUp>
            <span className="title-mobile">{headerName}</span>
          </Hidden>
          <nav className="nav-bar">
            <div className="header-button">
              <Search className="icon md" />
            </div>
            <GlobalMenu />
          </nav>
        </Grid>
        <Hidden smDown>
      <h2 className='title'>
      <Tab labels={labels} styleType="primary" defaultTab={0} handleChangeStatus={() => {
          store.dispatch(push(path[headerName]));
        }}/>
      </h2>
        </Hidden>
      </header>
    </Fragment>
  );
};

HeaderPres.propTypes = {
  headerName: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default HeaderPres;
